module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAjCAMAAAAKXBK+AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRFytnR2eri2tvb0+bd6vLt9PT0+fv66enpx9HLzuDX5O/p4eHi4e/n0dHR////3u7pjj1CDQAAAPpJREFUeNq01MGShCAMBNDEABqV5v//dkEFR0tnyGH75MFXTYIlwXFyAf0hpBwxKAqS9mQ19yia00dYeP1VRmu6p5S5bx2cnpLZSxuNml4jW93Nkfsi2nC8zs637f4UDRa5OsLAyRIhLGQSTPBRLEIJxpJ8KgRTSRFYJjbNgTyJGgXGfiFuE7NhDL8JwxgaigiGXSmKcEpGgdi/LMG+3cEoENB9LN4FIP8m2FXRe+vimzg/xolUXq9Um0AkVSURpZgzZabyeB1N+FgzDPUpuzv8EKjvDfn35MelsQOKHNdxir3Jn8/h6o7Gu3iIv8ClQ1zh2C/qUYE/AQYAgR9ak3LWBW4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/MT.png
// module id = oIEi
// module chunks = 1